
<!--div width="400" height="400">
<canvas id="my_first_chart">{{chart}}</canvas>
</div-->

<div id="wrapper">
  <header>CCXXXIX</header>
<h2>&Delta;   |    &Delta;<!--img src="./assets/kultur-icon.png"-->  Holzar Steiner -> 
  Stand 18.12.2025</h2>

<div class="example-container">
     <div class="example-container">
        <mat-form-field>
          <mat-label>Enter your password</mat-label>
          <input matInput placeholder="Password" [type]="hide ? 'password' : 'text'" [(ngModel)]="myPassword" (input)="onPasswordInput()">
          <button mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">
            <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
          </button>
        </mat-form-field>
      
        <!--h5>{{myPassword}}</h5-->
      </div>
<div *ngIf="hidecode">
   <h4> Im Schnitt sollte man {{sum_gesamttagschicht/sum_gesamtholz | number : '1.0-2'}} Tagschichten pro SRM Holz entnahme haben. </h4>
   <table class="mat-table"> <!--id="tab_sum"-->
    <tr></tr>
    <th class="mat-header-cell"> +/- Übersicht</th>
        <th class="mat-header-cell" [ngStyle]="{'background-color': 'blue'}">&#216;</th>
        <th class="mat-header-cell" [ngStyle]="{'background-color': this.b_greenmichi? 'green' : 'red'}">michi</th>
        <th class="mat-header-cell" [ngStyle]="{'background-color': this.b_greenthomas? 'green' : 'red'}">thomas</th>
        <th class="mat-header-cell" [ngStyle]="{'background-color': this.b_greenjoachim? 'green' : 'red'}">Joachim</th>
        <th class="mat-header-cell" [ngStyle]="{'background-color': this.b_greentobi? 'green' : 'red'}">Tobi</th>
        <th class="mat-header-cell" [ngStyle]="{'background-color': this.b_greenrobert? 'green' : 'red'}">Robert</th>
        <th class="mat-header-cell" [ngStyle]="{'background-color': this.b_greenchristian? 'green' : 'red'}">Christian</th>
        <th class="mat-header-cell" [ngStyle]="{'background-color': this.b_greenjosef? 'green' : 'red'}">Josef</th>
        <th class="mat-header-cell" [ngStyle]="{'background-color': this.b_greenluggi? 'green' : 'red'}">Luggi</th>
        <th class="mat-header-cell" [ngStyle]="{'background-color': this.b_greenflori? 'green' : 'red'}">Flori</th>
        <th class="mat-header-cell" [ngStyle]="{'background-color': this.b_greenlaurin? 'green' : 'red'}">Laurin</th>
        <th class="mat-header-cell" [ngStyle]="{'background-color': this.b_greenlinus? 'green' : 'red'}">Linus</th>
        <th class="mat-header-cell" [ngStyle]="{'background-color': this.b_greenmaxi? 'green' : 'red'}">maxi</th>
        <th class="mat-header-cell" [ngStyle]="{'background-color': this.b_greenlisa? 'green' : 'red'}">lisa</th>
        <tr>
          <td class="mat-cell">+/- Tagschichten</td>
          <td class=mat-footer-cell>0</td>
       <td class=mat-footer-cell>{{saldotag_michi | number : '1.0-2'}}</td>
      <td  class=mat-footer-cell>{{saldotag_thomas  | number : '1.0-2'}}</td>
      <td class=mat-footer-cell>{{saldotag_joachim  | number : '1.0-2'}}</td>
        <td class=mat-footer-cell>{{saldotag_tobi | number : '1.0-2'}}</td>
           <td class=mat-footer-cell>{{saldotag_robert | number : '1.0-2'}}</td>
      <td class=mat-footer-cell>{{saldotag_christian | number : '1.0-2'}}</td>
      <td class=mat-footer-cell>{{saldotag_josef  | number : '1.0-2'}}</td>
      <td class=mat-footer-cell>{{saldotag_luggi  | number : '1.0-2'}}</td>
      <td class=mat-footer-cell>{{saldotag_flori  | number : '1.0-2'}}</td>
      <td class=mat-footer-cell>{{saldotag_laurin  | number : '1.0-2'}}</td>
      <td class=mat-footer-cell>{{saldotag_linus | number : '1.0-2'}}</td>     
      <td class=mat-footer-cell>{{saldotag_maxi | number : '1.0-2'}}</td>
      <td class=mat-footer-cell>{{saldotag_lisa | number : '1.0-2'}}</td>    
      </tr>
      
      <tr>
          <td class="mat-cell">+/- Holz</td>
          <td class=mat-footer-cell>0</td>
          <td class=mat-footer-cell>{{ this.saldoholz_michi | number : '1.0-2'}}</td>
           <td class=mat-footer-cell>{{saldoholz_thomas | number : '1.0-2'}}</td>
           <td class=mat-footer-cell>{{saldoholz_joachim | number : '1.0-2'}}</td>
           <td class=mat-footer-cell>{{saldoholz_tobi | number : '1.0-2'}}</td>
           <td class=mat-footer-cell>{{saldoholz_robert | number : '1.0-2'}}</td>
      <td class=mat-footer-cell>{{saldoholz_christian | number : '1.0-2'}}</td>
      <td class=mat-footer-cell>{{saldoholz_josef  | number : '1.0-2'}}</td>
      <td class=mat-footer-cell>{{saldoholz_luggi  | number : '1.0-2'}}</td>
      <td class=mat-footer-cell>{{saldoholz_flori  | number : '1.0-2'}}</td>
      <td class=mat-footer-cell>{{saldoholz_laurin  | number : '1.0-2'}}</td>
      <td class=mat-footer-cell>{{ saldoholz_linus | number : '1.0-2'}}</td>   
      <td class=mat-footer-cell>{{ saldoholz_maxi | number : '1.0-2'}}</td>    
      <td class=mat-footer-cell>{{ saldoholz_lisa | number : '1.0-2'}}</td>   
      </tr>

        <tr>
    <td class="mat-cell">Holz/Tagschicht</td>
    <td class="mat-cell">{{sum_gesamtholz/sum_gesamttagschicht | number : '1.0-2'}}</td>
    <td class="mat-cell">{{sum_hmichi/sum_TSmichi | number : '1.0-2'}}</td>
    <td class="mat-cell">{{sum_hthomas/sum_TSthomas | number : '1.0-2'}}</td>
<td class="mat-cell">{{sum_hjoachim/sum_TSjoachim | number : '1.0-2'}}</td>

<td class="mat-cell">{{sum_htobi/sum_TStobi | number : '1.0-2'}}</td>
<td class="mat-cell">{{sum_hrobert/sum_TSrobert | number : '1.0-2'}}</td>
<td class="mat-cell">{{sum_hchristian/sum_TSchristian | number : '1.0-2'}}</td>
<td class="mat-cell">{{sum_hjosef/sum_TSjosef | number : '1.0-2'}}</td>
<td class="mat-cell">{{sum_hluggi/sum_TSluggi | number : '1.0-2'}}</td>
<td class="mat-cell">{{sum_hflori/sum_TSflori | number : '1.0-2'}}</td>
<td class="mat-cell">{{sum_hlaurin/sum_TSlaurin | number : '1.0-2'}}</td>
<td class="mat-cell">{{ sum_hlinus/sum_TSlinus | number : '1.0-2'}}</td>  
<td class="mat-cell">{{ sum_hmaxi/sum_TSmaxi | number : '1.0-2'}}</td> 
<td class="mat-cell">{{ sum_hlisa/sum_TSlisa | number : '1.0-2'}}</td> 
</tr>
<tr>
 <td class="mat-cell">Tagschichten/Holz</td>
 <td class="mat-cell">{{sum_gesamttagschicht/sum_gesamtholz | number : '1.0-2'}}</td>
 <td class="mat-cell">{{sum_TSmichi/sum_hmichi | number : '1.0-2'}}</td>
 <td class="mat-cell">{{sum_TSthomas/sum_hthomas | number : '1.0-2'}}</td>
 <td class="mat-cell">{{sum_TSjoachim/sum_hjoachim | number : '1.0-2'}}</td>
 
 <td class="mat-cell">{{sum_TStobi/sum_htobi | number : '1.0-2'}}</td>
 <td class="mat-cell">{{sum_TSrobert/sum_hrobert | number : '1.0-2'}}</td>
 <td class="mat-cell">{{sum_TSchristian/sum_hchristian | number : '1.0-2'}}</td>
 <td class="mat-cell">{{sum_TSjosef/sum_hjosef | number : '1.0-2'}}</td>
 <td class="mat-cell">{{sum_TSluggi/sum_hluggi | number : '1.0-2'}}</td>
 <td class="mat-cell">{{sum_TSflori/sum_hflori | number : '1.0-2'}}</td>
 <td class="mat-cell">{{sum_TSlaurin/sum_hlaurin | number : '1.0-2'}}</td>
 <td class="mat-cell">{{ sum_TSlinus/sum_hlinus | number : '1.0-2'}}</td>  
 <td class="mat-cell">{{ sum_TSmaxi/sum_hmaxi | number : '1.0-2'}}</td>  
 <td class="mat-cell">{{ sum_TSlisa/sum_hlisa | number : '1.0-2'}}</td>    
</tr>
</table>
  <mat-grid-list cols="1" [gutterSize]="'50px'" class="grid-layout-custom">
  
             <!--ngcontainer-->
                <!--h4 class="card-title">Absolut Tagschichten und Holz  -> </h4-->
                <mat-grid-tile>
                  <mat-grid-tile-header>****** Übersicht Tagschichten und Holzentnahme (extra)******</mat-grid-tile-header>
           
                <canvas id="pie-container"
                  baseChart
                  [data]="TagschichtenData"
                  [type]="'bar'"
                  [options]="chartTagschichtenOptions"
                >
                </canvas>
             
                <mat-grid-tile-footer></mat-grid-tile-footer>
              </mat-grid-tile>   
                
          
              <!--/ngcontainer-->
           
              <!--h4 class="card-title">Tagschichten / Holz -> "lineChartColors"</h4-->
              <mat-grid-tile>
                <mat-grid-tile-header>**** Tagschichten geteilt durch Holzentnahme TS / SRM ****</mat-grid-tile-header>
   
            <canvas id="pie-container"
              baseChart
              [data]="HolzzuTagschichtenData"
              [type]="'bar'"
              [options]="chartHolzzuTagschichtenOptions"
          
              
            >
            </canvas>
             
            <mat-grid-tile-footer></mat-grid-tile-footer>
          </mat-grid-tile>
       
          <!--h2 class="card-title">Pie Tagschichten / Holz -> </h2--> 
          <!--div style="position: relative; height:90vmin; width: 80vmin;">
      
        <canvas id="pie-container"
          baseChart
          [data]="pieTagzuHolzData"
          [type]="'pie'"
          [options]="chartLineVerlaufOptions"
        >
        </canvas>
      </div--> 
             
      
 
  <!--tr style="width:70%; height:60%">
    <div style="width:70%; height:60%">
<h2 class="card-title">Doughnut Tagschichten / Holz -> </h2>
<canvas style="width:70%; height:60%"
 baseChart
 [data]="pieTagzuHolzData"
 [type]="'doughnut'"
 [options]="chartLineVerlaufOptions"
>
</canvas>
    </div>

</tr-->

          
<mat-grid-tile>
  <mat-grid-tile-header>Zahl Tagschichten oder SRM Holz um im &#216; zu sein</mat-grid-tile-header>
 
            <!--h3 class="card-title">+/- Übersicht:</h3-->
              <canvas id="pie-container"
              baseChart
              [data]="plusminusData"
              [type]="'bar'"
              [options]="chartplusminusOptions"
             
            >
            </canvas>
      
            <mat-grid-tile-footer></mat-grid-tile-footer>
</mat-grid-tile> 
          <!--tr>
             
                <h4 class="card-title">Tagschichten über die Jahre</h4>
                <canvas
                  baseChart
                  [data]="LineData"
                  [type]="'bar'"
                  [options]="chartLineOptions"
                >
                </canvas>    
          </tr>
          <tr>
             
            <h4 class="card-title">Holz/Tag</h4>
            <canvas
              baseChart
              [data]="HolzzuTagData"
              [type]="'bar'"
              [options]="chartHolzOptions"
            >
            </canvas>    
      </tr-->
      <!--tr>
             
        <h4 class="card-title">Tagschichten über die Jahre</h4>
        <canvas
          baseChart
          [data]="LineData"
          [type]="'bar'"
          [options]="chartLineOptions"
        >
        </canvas>    
  </tr-->  <!--tr>
             
    <h4 class="card-title">Verlauf Holz / Tagschichten über die Jahre</h4>
    <canvas
      baseChart
      [data]="VerlaufData"
      [type]="'line'"
      [options]="chartLineVerlaufOptions"
    >
    </canvas>    
</tr>
<tr>
             

  <canvas
    baseChart
    [data]="VerlaufData"
    [type]="'bar'"
    [options]="chartLineVerlaufOptions"
  >
  </canvas>    
</tr-->
<!--ng-container-->

<mat-grid-tile> 
  <mat-grid-tile-header>Verlauf Tagschichten / Holz über die Jahre
  </mat-grid-tile-header>

  <canvas
    baseChart #myChart id="pie-container"
    [data]="VerlaufTagzuHolzData"
    [type]="'line'"
    [options]="chartplusminusOptions"
   
  >
  </canvas> 
  <mat-grid-tile-footer>

    
     
</mat-grid-tile-footer>
  <!--input (input)="updateChart()" [(ngModel)]="myRange"  type="range" id="points" min="2" max="8"-->

</mat-grid-tile>

 



<mat-grid-tile>
<mat-grid-tile-header>
  Kultur Holzar -> Holz <font color=blue>Tagschichten</font> | <font color=brown>Holzeinbringung [fm]</font> | <font color=darkgreen>Scheiter [srm] | Holzbuendel [ster]</font>
  | <font color=orange>Pfähl</font>
</mat-grid-tile-header>

<table mat-table class="lessons-table mat-elevation-z8" [dataSource]="KulturP">
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <ng-container matColumnDef="year">
        <th mat-header-cell *matHeaderCellDef>Jahr</th>
        <td *matCellDef="let lesson">{{lesson.year}}</td>
        <td mat-footer-cell *matFooterCellDef>Summe [Tage] | [SRM]</td> 
    </ng-container>
    <ng-container matColumnDef="michi">
        <th mat-header-cell *matHeaderCellDef>michi</th>
        <td *matCellDef="let lesson">
          <div *ngIf="lesson.michi">
          <font color=blue>{{lesson.michi | number : '1.0-2' }}</font> | </div>
          <div *ngIf="lesson.michi_hzeinbring">
          <font color=brown>{{lesson.michi_hzeinbring | number : '1.0-2' }}</font> |
        </div>
        <div *ngIf="lesson.hsch_michi">
        <font color=green>{{lesson.hsch_michi | number : '1.0-2' }} </font> |</div>
        <div *ngIf="lesson.hb_michi">
         <font color=darkgreen>{{lesson.hb_michi | number : '1.0-2' }}</font>
          | </div>
          <div *ngIf="lesson.hp_michi"><font color=orange>{{lesson.hp_michi | number : '1.0-2' }}</font></div></td>
        <td mat-footer-cell *matFooterCellDef><font color=blue>{{sum_TSmichi | number : '1.0-2'}}</font> | <font color=green>{{sum_hmichi | number : '1.0-2'}}</font></td>   
    </ng-container>
  
    <ng-container matColumnDef="thomas">
      <th mat-header-cell *matHeaderCellDef>thomas</th>
      <td *matCellDef="let lesson">
        <div *ngIf="lesson.thomas">
        <font color=blue>{{lesson.thomas | number : '1.0-2' }}</font> | </div>
        <div *ngIf="lesson.thomas_hzeinbring">
        <font color=brown>{{lesson.thomas_hzeinbring | number : '1.0-2' }}</font> |
      </div>
      <div *ngIf="lesson.hsch_thomas">
      <font color=green>{{lesson.hsch_thomas | number : '1.0-2' }} </font> |</div>
      <div *ngIf="lesson.hb_thomas">
       <font color=darkgreen>{{lesson.hb_thomas | number : '1.0-2' }}</font>
        | </div>
        <div *ngIf="lesson.hp_thomas"><font color=orange>{{lesson.hp_thomas | number : '1.0-2' }}</font></div></td>
      <td mat-footer-cell *matFooterCellDef><font color=blue>{{sum_TSthomas | number : '1.0-2'}}</font> | <font color=green>{{sum_hthomas | number : '1.0-2'}}</font></td>   
  </ng-container>

  <ng-container matColumnDef="joachim">
    <th mat-header-cell *matHeaderCellDef>joachim</th>
    <td *matCellDef="let lesson">
      <div *ngIf="lesson.joachim">
      <font color=blue>{{lesson.joachim | number : '1.0-2' }}</font> | </div>
      <div *ngIf="lesson.joachim_hzeinbring">
      <font color=brown>{{lesson.joachim_hzeinbring | number : '1.0-2' }}</font> |
    </div>
    <div *ngIf="lesson.hsch_joachim">
    <font color=green>{{lesson.hsch_joachim | number : '1.0-2' }} </font> |</div>
    <div *ngIf="lesson.hb_joachim">
     <font color=darkgreen>{{lesson.hb_joachim | number : '1.0-2' }}</font>
      | </div>
      <div *ngIf="lesson.hp_joachim"><font color=orange>{{lesson.hp_joachim | number : '1.0-2' }}</font></div></td>
    <td mat-footer-cell *matFooterCellDef><font color=blue>{{sum_TSjoachim | number : '1.0-2'}}</font> | <font color=green>{{sum_hjoachim | number : '1.0-2'}}</font></td>   
  </ng-container>

    <ng-container matColumnDef="tobi">
      <th mat-header-cell *matHeaderCellDef>tobi</th>
      <td *matCellDef="let lesson">
        <div *ngIf="lesson.tobi">
        <font color=blue>{{lesson.tobi | number : '1.0-2' }}</font> | </div>
        <div *ngIf="lesson.tobi_hzeinbring">
        <font color=brown>{{lesson.tobi_hzeinbring | number : '1.0-2' }}</font> |
      </div>
      <div *ngIf="lesson.hsch_tobi">
      <font color=green>{{lesson.hsch_tobi | number : '1.0-2' }} </font> |</div>
      <div *ngIf="lesson.hb_tobi">
       <font color=darkgreen>{{lesson.hb_tobi | number : '1.0-2' }}</font>
        | </div>
        <div *ngIf="lesson.hp_tobi"><font color=orange>{{lesson.hp_tobi | number : '1.0-2' }}</font></div></td>
      <td mat-footer-cell *matFooterCellDef><font color=blue>{{sum_TStobi | number : '1.0-2'}}</font> | <font color=green>{{sum_htobi | number : '1.0-2'}}</font></td>   
  </ng-container>

  <ng-container matColumnDef="robert">
    <th mat-header-cell *matHeaderCellDef>robert</th>
    <td *matCellDef="let lesson">
      <div *ngIf="lesson.robert">
      <font color=blue>{{lesson.robert | number : '1.0-2' }}</font> | </div>
      <div *ngIf="lesson.robert_hzeinbring">
      <font color=brown>{{lesson.robert_hzeinbring | number : '1.0-2' }}</font> |
    </div>
    <div *ngIf="lesson.hsch_robert">
    <font color=green>{{lesson.hsch_robert | number : '1.0-2' }} </font> |</div>
    <div *ngIf="lesson.hb_robert">
     <font color=darkgreen>{{lesson.hb_robert | number : '1.0-2' }}</font>
      | </div>
      <div *ngIf="lesson.hp_robert"><font color=orange>{{lesson.hp_robert | number : '1.0-2' }}</font></div></td>
    <td mat-footer-cell *matFooterCellDef><font color=blue>{{sum_TSrobert | number : '1.0-2'}}</font> | <font color=green>{{sum_hrobert | number : '1.0-2'}}</font></td>   
</ng-container>

<ng-container matColumnDef="christian">
  <th mat-header-cell *matHeaderCellDef>christian</th>
  <td *matCellDef="let lesson">
    <div *ngIf="lesson.christian">
    <font color=blue>{{lesson.christian | number : '1.0-2' }}</font> | </div>
    <div *ngIf="lesson.christian_hzeinbring">
    <font color=brown>{{lesson.christian_hzeinbring | number : '1.0-2' }}</font> |
  </div>
  <div *ngIf="lesson.hsch_christian">
  <font color=green>{{lesson.hsch_christian | number : '1.0-2' }} </font> |</div>
  <div *ngIf="lesson.hb_christian">
   <font color=darkgreen>{{lesson.hb_christian | number : '1.0-2' }}</font>
    | </div>
    <div *ngIf="lesson.hp_christian"><font color=orange>{{lesson.hp_christian | number : '1.0-2' }}</font></div></td>
  <td mat-footer-cell *matFooterCellDef><font color=blue>{{sum_TSchristian | number : '1.0-2'}}</font> | <font color=green>{{sum_hchristian | number : '1.0-2'}}</font></td>   
</ng-container>

<ng-container matColumnDef="josef">
  <th mat-header-cell *matHeaderCellDef>josef</th>
  <td *matCellDef="let lesson">
    <div *ngIf="lesson.josef">
    <font color=blue>{{lesson.josef | number : '1.0-2' }}</font> | </div>
    <div *ngIf="lesson.josef_hzeinbring">
    <font color=brown>{{lesson.josef_hzeinbring | number : '1.0-2' }}</font> |
  </div>
  <div *ngIf="lesson.hsch_josef">
  <font color=green>{{lesson.hsch_josef | number : '1.0-2' }} </font> |</div>
  <div *ngIf="lesson.hb_josef">
   <font color=darkgreen>{{lesson.hb_josef | number : '1.0-2' }}</font>
    | </div>
    <div *ngIf="lesson.hp_josef"><font color=orange>{{lesson.hp_josef | number : '1.0-2' }}</font></div></td>
  <td mat-footer-cell *matFooterCellDef><font color=blue>{{sum_TSjosef | number : '1.0-2'}}</font> | <font color=green>{{sum_hjosef | number : '1.0-2'}}</font></td>   
</ng-container>
   <ng-container matColumnDef="luggi">
  <th mat-header-cell *matHeaderCellDef>luggi</th>
  <td *matCellDef="let lesson">
    <div *ngIf="lesson.luggi">
    <font color=blue>{{lesson.luggi | number : '1.0-2' }}</font> | </div>
    <div *ngIf="lesson.luggi_hzeinbring">
    <font color=brown>{{lesson.luggi_hzeinbring | number : '1.0-2' }}</font> |
  </div>
  <div *ngIf="lesson.hsch_luggi">
  <font color=green>{{lesson.hsch_luggi | number : '1.0-2' }} </font> |</div>
  <div *ngIf="lesson.hb_luggi">
   <font color=darkgreen>{{lesson.hb_luggi | number : '1.0-2' }}</font>
    | </div>
    <div *ngIf="lesson.hp_luggi"><font color=orange>{{lesson.hp_luggi | number : '1.0-2' }}</font></div></td>
  <td mat-footer-cell *matFooterCellDef><font color=blue>{{sum_TSluggi | number : '1.0-2'}}</font> | <font color=green>{{sum_hluggi | number : '1.0-2'}}</font></td>   
</ng-container>

<ng-container matColumnDef="flori">
  <th mat-header-cell *matHeaderCellDef>flori</th>
  <td *matCellDef="let lesson">
    <div *ngIf="lesson.flori">
    <font color=blue>{{lesson.flori | number : '1.0-2' }}</font> | </div>
    <div *ngIf="lesson.flori_hzeinbring">
    <font color=brown>{{lesson.flori_hzeinbring | number : '1.0-2' }}</font> |
  </div>
  <div *ngIf="lesson.hsch_flori">
  <font color=green>{{lesson.hsch_flori | number : '1.0-2' }} </font> |</div>
  <div *ngIf="lesson.hb_flori">
   <font color=darkgreen>{{lesson.hb_flori | number : '1.0-2' }}</font>
    | </div>
    <div *ngIf="lesson.hp_flori"><font color=orange>{{lesson.hp_flori | number : '1.0-2' }}</font></div></td>
  <td mat-footer-cell *matFooterCellDef><font color=blue>{{sum_TSflori | number : '1.0-2'}}</font> | <font color=green>{{sum_hflori | number : '1.0-2'}}</font></td>   
</ng-container>
<ng-container matColumnDef="laurin">
  <th mat-header-cell *matHeaderCellDef>laurin</th>
  <td *matCellDef="let lesson">
    <div *ngIf="lesson.laurin">
    <font color=blue>{{lesson.laurin | number : '1.0-2' }}</font> | </div>
    <div *ngIf="lesson.laurin_hzeinbring">
    <font color=brown>{{lesson.laurin_hzeinbring | number : '1.0-2' }}</font> |
  </div>
  <div *ngIf="lesson.hsch_laurin">
  <font color=green>{{lesson.hsch_laurin | number : '1.0-2' }} </font> |</div>
  <div *ngIf="lesson.hb_laurin">
   <font color=darkgreen>{{lesson.hb_laurin | number : '1.0-2' }}</font>
    | </div>
    <div *ngIf="lesson.hp_laurin"><font color=orange>{{lesson.hp_laurin | number : '1.0-2' }}</font></div></td>
  <td mat-footer-cell *matFooterCellDef><font color=blue>{{sum_TSlaurin | number : '1.0-2'}}</font> | <font color=green>{{sum_hlaurin | number : '1.0-2'}}</font></td>   
</ng-container>
<ng-container matColumnDef="linus">
  <th mat-header-cell *matHeaderCellDef>linus</th>
  <td *matCellDef="let lesson">
    <div *ngIf="lesson.linus">
    <font color=blue>{{lesson.linus | number : '1.0-2' }}</font> | </div>
    <div *ngIf="lesson.linus_hzeinbring">
    <font color=brown>{{lesson.linus_hzeinbring | number : '1.0-2' }}</font> |
  </div>
  <div *ngIf="lesson.hsch_linus">
  <font color=green>{{lesson.hsch_linus | number : '1.0-2' }} </font> |</div>
  <div *ngIf="lesson.hb_linus">
   <font color=darkgreen>{{lesson.hb_linus | number : '1.0-2' }}</font>
    | </div>
    <div *ngIf="lesson.hp_linus"><font color=orange>{{lesson.hp_linus | number : '1.0-2' }}</font></div></td>
  <td mat-footer-cell *matFooterCellDef><font color=blue>{{sum_TSlinus | number : '1.0-2'}}</font> | <font color=green>{{sum_hlinus | number : '1.0-2'}}</font></td>   
</ng-container>
<ng-container matColumnDef="maxi">
  <th mat-header-cell *matHeaderCellDef>maxi</th>
  <td *matCellDef="let lesson">
    <div *ngIf="lesson.maxi">
    <font color=blue>{{lesson.maxi | number : '1.0-2' }}</font> | </div>
    <div *ngIf="lesson.maxi_hzeinbring">
    <font color=brown>{{lesson.maxi_hzeinbring | number : '1.0-2' }}</font> |
  </div>
  <div *ngIf="lesson.hsch_maxi">
  <font color=green>{{lesson.hsch_maxi | number : '1.0-2' }} </font> |</div>
  <div *ngIf="lesson.hb_maxi">
   <font color=darkgreen>{{lesson.hb_maxi | number : '1.0-2' }}</font>
    | </div>
    <div *ngIf="lesson.hp_maxi"><font color=orange>{{lesson.hp_maxi | number : '1.0-2' }}</font></div></td>
  <td mat-footer-cell *matFooterCellDef><font color=blue>{{sum_TSmaxi | number : '1.0-2'}}</font> | <font color=green>{{sum_hmaxi | number : '1.0-2'}}</font></td>   
</ng-container>
<ng-container matColumnDef="lisa">
  <th mat-header-cell *matHeaderCellDef>lisa</th>
  <td *matCellDef="let lesson">
    <div *ngIf="lesson.lisa">
    <font color=blue>{{lesson.lisa | number : '1.0-2' }}</font> | </div>
    <div *ngIf="lesson.lisa_hzeinbring">
    <font color=brown>{{lesson.lisa_hzeinbring | number : '1.0-2' }}</font> |
  </div>
  <div *ngIf="lesson.hsch_lisa">
  <font color=green>{{lesson.hsch_lisa | number : '1.0-2' }} </font> |</div>
  <div *ngIf="lesson.hb_lisa">
   <font color=darkgreen>{{lesson.hb_lisa | number : '1.0-2' }}</font>
    | </div>
    <div *ngIf="lesson.hp_lisa"><font color=orange>{{lesson.hp_lisa | number : '1.0-2' }}</font></div></td>
  <td mat-footer-cell *matFooterCellDef><font color=blue>{{sum_TSlisa | number : '1.0-2'}}</font> | <font color=green>{{sum_hlisa | number : '1.0-2'}}</font></td>   
</ng-container>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    <tr mat-footer-row *matFooterRowDef="displayedColumns" class="footer-row"></tr>
</table>

</mat-grid-tile>





<mat-grid-tile>
  <mat-grid-tile-header>letzte Tagschichten</mat-grid-tile-header>
  <img src="./assets/schichten-aktuell.png" class="responsive">
</mat-grid-tile>

<mat-grid-tile>
  <mat-grid-tile-header>letzte Holzentnahmen</mat-grid-tile-header>
  <img src="./assets/holz-aktuell.png" class="responsive">
</mat-grid-tile>

<mat-grid-tile> 
  <mat-grid-tile-header>Zusammenfassung</mat-grid-tile-header>
  <ul><b>Summen</b>
    <li>Tagschichten Gesamt: {{sum_gesamttagschicht  | number : '1.0-2'}}</li>
    <li>Holz Gesamt: {{sum_gesamtholz  | number : '1.0-2'}} [srm]</li>
    <li>Tagschicht zu Holz &#216; {{sum_gesamttagschicht/sum_gesamtholz  | number : '1.0-2'}} [tag]/[srm]</li>
  </ul>

  <ul><b>VK</b>
<li>Summe Bündelvk: {{sum_vk_ballen}}[ster] == {{sum_vk_ballen*fak_ster_zu_srm | number : '1.0-2'}} [srm]</li>
<li>Summe Scheitervk: {{sum_vk_scheiter}} [srm]</li>
<li>Summe Holzvk: {{sum_vk_scheiter+(sum_vk_ballen*fak_ster_zu_srm) | number : '1.0-2'}} [srm]</li>
  </ul>


  <ul><b>Besprechungen</b>
    <li>momentan verwendete Umrechnung Ster -> RM 1Ster ===> {{fak_ster_zu_srm | number : '1.0-2'}} SRM</li>
    <li>Ausgemacht Einbringung Stammholz verrechnet 5 fm-> 1 Tagschicht </li>
    <li>Ausgemacht Einbringung Stammholz verrechnet 5 fm-> 1 Tagschicht</li>
    <li>Traktorstunden: momentan 160 € / Jahr , wird jährlich neu angepasst Stunden / Dieselpreis</li>
    <li>Zaunpfähle verrechnet 30 Pfähle -> 2 SRM ...</li>

  </ul>
</mat-grid-tile> 
<mat-grid-tile>
  <mat-grid-tile-header>Dokumente</mat-grid-tile-header>
  <ul><b>Dokumente Seni</b>
    <li><a href="./assets/seni/Holz Besprechung aktuell.pdf" target="_blank">Besprechung Protokoll</a></li>
    <li><a href="./assets/seni/Gemeinsame Sachen.pdf" target="_blank">Gemeinsame Sachen</a></li>
    <li><a href="./assets/seni/Holz Bänder und Schlupf Farbig.pdf" target="_blank">Bänder Schlupf 1</a></li>
    <li><a href="./assets/seni/Holz Bänder und Schlupf Farbig 2.pdf" target="_blank">Bänder Schlupf </a></li>
    <li><a href="./assets/seni/Bei nächster Versammlung fragen.pdf" target="_blank">offene Fragen</a></li>
    </ul>

</mat-grid-tile> 

</mat-grid-list>
<!--p>Kultur</p>
<iframe src='https://geoportal.bayern.de/bayernatlas/embed.html?lang=de&topic=ba&bgLayer=atkis&catalogNodes=11&layers=luftbild_parz&E=619427.77&N=5268894.53&zoom=13' width='600' height='450' frameborder='0' style='border:0'></iframe>

<p>Hauge Tal</p>
<iframe src='https://geoportal.bayern.de/bayernatlas/embed.html?lang=de&topic=ba&bgLayer=atkis&catalogNodes=11&layers=luftbild_parz&E=614277.75&N=5268051.57&zoom=13' width='600' height='450' frameborder='0' style='border:0'></iframe>
<p>Quelle: BayernAtlas</p-->

</div>
</div>

</div>
<!--footer>&#216;<img src="./assets/kultur-icon.png">CCXXXIX<a href="./assets/3rdpartylicenses.txt">Lizenzen</a></footer>
<&#9650;|&#9650;   &Delta; &Pi; &Delta;-->